export const SET_AGENTS = 'SET_AGENTS';
export const SET_INFO = 'SET_INFO';
export const SET_SEARCH_AGENTS = 'SET_SEARCH_AGENTS';
